import { WAIT, WAIT_SUCCESS, WAIT_FAIL, ECXEPTION } from "../actions/types";

const initialState = {
    isLoading: false,
    isError: false,
    payload: undefined
};

export default function store(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case WAIT:
            return {
                ...state,
                isLoading: true,
                isError: false,
                payload: undefined
            };
        case WAIT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
            };
        case WAIT_FAIL:
            return {
                ...state,
                isLoading: false,
                isError: true,
            };
        case ECXEPTION:
            return {
                ...state,
                isLoading: false,
                isError: true,
                payload,
            };
        default:
            return state;
    }
}